module.exports = __webpack_public_path__ + "media/images/menu/leda-bb78678abf94b80165a25a408e4cbb83.jpg";